import { mergeAttributes } from '@tiptap/core'
import TiptapLink from '@tiptap/extension-link'
import { Plugin } from '@tiptap/pm/state'
import { EditorView } from '@tiptap/pm/view'

export const Link = TiptapLink.extend({
  inclusive: false,

  addAttributes() {
    return {
      href: {
        default: null,
      },
      target: {
        default: this.options.HTMLAttributes.target,
      },
      rel: {
        default: this.options.HTMLAttributes.rel,
      },
      class: {
        default: this.options.HTMLAttributes.class,
      },
      linktype: {
        default: 'link',
        renderHTML: (attributes: any) => ({
          'data-linktype': attributes.linktype,
          class: `linktype-${attributes.linktype}`,
        }),
      },
      bgcolor: {
        default: null,
        renderHTML: (attributes: any) => {
          if (attributes.linktype !== 'button') return null
          return {
            'data-bgcolor': attributes.bgcolor,
            style: attributes.bgcolor ? `background-color: ${attributes.bgcolor};` : undefined,
          }
        },
      },
    }
  },

  parseHTML() {
    return [{ tag: 'a[href]:not([data-type="button"]):not([href *= "javascript:" i])' }]
  },

  renderHTML({ HTMLAttributes }: { HTMLAttributes: any }) {
    const { rel, ...rest } = HTMLAttributes
    return ['a', mergeAttributes(this.options.HTMLAttributes, rest), 0]
  },

  addProseMirrorPlugins() {
    const { editor } = this

    return [
      new Plugin({
        props: {
          handleKeyDown: (view: EditorView, event: KeyboardEvent) => {
            const { selection } = editor.state

            if (event.key === 'Escape' && selection.empty !== true) {
              editor.commands.focus(selection.to, { scrollIntoView: false })
            }

            return false
          },
        },
      }),
    ]
  },
})

export default Link
